import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { equals, uint8_type, bool_type, class_type, list_type, int32_type, record_type, option_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { InvoiceeDetails, InvoiceeTerminationState$reflection, InvoiceeBlock$reflection, InvoiceeBlock_get_ListDecoder, InvoiceSettings$reflection, Address$reflection } from "../Containers/Invoicee/Common.js";
import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Map, FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { map, bind, defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { compare, uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { fromString as fromString_1 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { DateModule_parse, DateFormat_get_yyyy$002DMM$002Ddd } from "../Svea.Dry/Time.js";
import { TerminationStateModule_fromString, InvoiceePaymentStateModule_fromString, PaymentMethodModule_ofString, BillingIntervalModule_fromInt, InvoiceeTypeModule_ofString, VatModeModule_ofExclVat, DistributionModule_ofCode, InvoiceeStateModule_ofString } from "../DomainTypes.js";
import { createThunk } from "../Redux/Redux.js";
import { setInvoiceeTerminationState, setInvoiceeBlock, setInvoiceeCurrentState, setInvoiceeDetails } from "../Redux/Reducers/InvoiceeReducer.js";
import { LoadState$2 } from "../Global.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { logei } from "../Utils.js";
import { sortByDescending } from "../fable_modules/fable-library.3.7.20/List.js";

export class InvoiceeCurrentState extends Record {
    constructor(CurrentState) {
        super();
        this.CurrentState = CurrentState;
    }
}

export function InvoiceeCurrentState$reflection() {
    return record_type("Api.Invoicee.InvoiceeCurrentState", [], InvoiceeCurrentState, () => [["CurrentState", option_type(string_type)]]);
}

export class UnvalidatedInvoiceeDetails extends Record {
    constructor(Address, BilledTo, ClientContactReference, ClientCrossRef, ContactPhoneNumber, ContractNumbers, CountryCode, Created, CurrentState, CustomerGroupCode, DistributionCode, ExcludeInvoiceFee, Email, ExclVat, InvoiceSettings, InvoiceeType, InvoiceeContactReference, InvoiceeNr, MonthlyBillingInterval, MortgageBlocked, Name, NoNextInvoice, OrganizationNr, PaymentTermsNetDays, HasAutomaticInvoiceFee, CompanyVatHandle, Updated, ManualDistributionChannel, EmailAddressInvoice, PaymentMethod, PaymentState, InvoiceeBatchId, OurReference, PaymentTermsFixedDay, EInvoiceIdentifier, CurrencyCode, TerminationState) {
        super();
        this.Address = Address;
        this.BilledTo = BilledTo;
        this.ClientContactReference = ClientContactReference;
        this.ClientCrossRef = ClientCrossRef;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.ContractNumbers = ContractNumbers;
        this.CountryCode = CountryCode;
        this.Created = Created;
        this.CurrentState = CurrentState;
        this.CustomerGroupCode = CustomerGroupCode;
        this.DistributionCode = (DistributionCode | 0);
        this.ExcludeInvoiceFee = ExcludeInvoiceFee;
        this.Email = Email;
        this.ExclVat = ExclVat;
        this.InvoiceSettings = InvoiceSettings;
        this.InvoiceeType = InvoiceeType;
        this.InvoiceeContactReference = InvoiceeContactReference;
        this.InvoiceeNr = InvoiceeNr;
        this.MonthlyBillingInterval = (MonthlyBillingInterval | 0);
        this.MortgageBlocked = MortgageBlocked;
        this.Name = Name;
        this.NoNextInvoice = NoNextInvoice;
        this.OrganizationNr = OrganizationNr;
        this.PaymentTermsNetDays = PaymentTermsNetDays;
        this.HasAutomaticInvoiceFee = HasAutomaticInvoiceFee;
        this.CompanyVatHandle = CompanyVatHandle;
        this.Updated = Updated;
        this.ManualDistributionChannel = ManualDistributionChannel;
        this.EmailAddressInvoice = EmailAddressInvoice;
        this.PaymentMethod = PaymentMethod;
        this.PaymentState = PaymentState;
        this.InvoiceeBatchId = (InvoiceeBatchId | 0);
        this.OurReference = OurReference;
        this.PaymentTermsFixedDay = PaymentTermsFixedDay;
        this.EInvoiceIdentifier = EInvoiceIdentifier;
        this.CurrencyCode = CurrencyCode;
        this.TerminationState = TerminationState;
    }
}

export function UnvalidatedInvoiceeDetails$reflection() {
    return record_type("Api.Invoicee.UnvalidatedInvoiceeDetails", [], UnvalidatedInvoiceeDetails, () => [["Address", option_type(Address$reflection())], ["BilledTo", option_type(string_type)], ["ClientContactReference", string_type], ["ClientCrossRef", option_type(string_type)], ["ContactPhoneNumber", string_type], ["ContractNumbers", list_type(int32_type)], ["CountryCode", string_type], ["Created", class_type("System.DateTime")], ["CurrentState", string_type], ["CustomerGroupCode", option_type(int32_type)], ["DistributionCode", int32_type], ["ExcludeInvoiceFee", bool_type], ["Email", string_type], ["ExclVat", bool_type], ["InvoiceSettings", InvoiceSettings$reflection()], ["InvoiceeType", string_type], ["InvoiceeContactReference", string_type], ["InvoiceeNr", class_type("System.Int64")], ["MonthlyBillingInterval", int32_type], ["MortgageBlocked", bool_type], ["Name", string_type], ["NoNextInvoice", bool_type], ["OrganizationNr", string_type], ["PaymentTermsNetDays", option_type(int32_type)], ["HasAutomaticInvoiceFee", option_type(bool_type)], ["CompanyVatHandle", option_type(uint8_type)], ["Updated", class_type("System.DateTime")], ["ManualDistributionChannel", bool_type], ["EmailAddressInvoice", option_type(string_type)], ["PaymentMethod", string_type], ["PaymentState", string_type], ["InvoiceeBatchId", int32_type], ["OurReference", option_type(string_type)], ["PaymentTermsFixedDay", option_type(int32_type)], ["EInvoiceIdentifier", option_type(string_type)], ["CurrencyCode", option_type(string_type)], ["TerminationState", option_type(string_type)]]);
}

export function loadInvoiceeDetails(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoicee/%i/%i/"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(UnvalidatedInvoiceeDetails$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(UnvalidatedInvoiceeDetails$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(UnvalidatedInvoiceeDetails$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadInvoiceeCurrentState(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoicee/CurrentState/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(InvoiceeCurrentState$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(InvoiceeCurrentState$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(InvoiceeCurrentState$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadInvoiceeBlock(clientNr, invoiceeNr) {
    const url = `/Invoicee/Block/${clientNr}/${invoiceeNr}`;
    let decoder_1;
    const decoder = InvoiceeBlock_get_ListDecoder();
    decoder_1 = ((value) => fromString_1(uncurry(2, decoder), value));
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, url));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const caseStrategy_1 = defaultArg(void 0, new CaseStrategy(0));
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(InvoiceeBlock$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : decoder_1(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadInvoiceeTerminationState(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/termination_process/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(InvoiceeTerminationState$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(InvoiceeTerminationState$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(InvoiceeTerminationState$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

function validateInvoiceeDetails(details) {
    let format;
    return new InvoiceeDetails(details.Address, bind((format = DateFormat_get_yyyy$002DMM$002Ddd(), (s) => DateModule_parse(format, s)), details.BilledTo), details.ClientContactReference, details.ClientCrossRef, details.ContactPhoneNumber, details.ContractNumbers, details.CountryCode, details.Created, InvoiceeStateModule_ofString(details.CurrentState), details.CustomerGroupCode, DistributionModule_ofCode(details.DistributionCode), !details.ExcludeInvoiceFee, details.Email, details.EmailAddressInvoice, details.EInvoiceIdentifier, details.CurrencyCode, VatModeModule_ofExclVat(details.ExclVat), details.InvoiceSettings, InvoiceeTypeModule_ofString(details.InvoiceeType), details.InvoiceeBatchId, details.InvoiceeContactReference, details.InvoiceeNr, details.ManualDistributionChannel, BillingIntervalModule_fromInt(details.MonthlyBillingInterval), details.MortgageBlocked, details.Name, details.NoNextInvoice, details.OrganizationNr.trim(), details.OurReference, PaymentMethodModule_ofString(details.PaymentMethod), InvoiceePaymentStateModule_fromString(details.PaymentState), details.PaymentTermsFixedDay, details.PaymentTermsNetDays, details.Updated, TerminationStateModule_fromString(defaultArg(details.TerminationState, "")));
}

export function loadInvoiceeThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Invoicee.InvoiceeDetails.tag === 1) {
        }
        else {
            const dispatchSetInvoiceeDetailsAction = (arg) => {
                dispatch(setInvoiceeDetails(arg));
            };
            if (getState().Invoicee.InvoiceeDetails.tag === 2) {
            }
            else {
                dispatchSetInvoiceeDetailsAction(new LoadState$2(1));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadInvoiceeDetails(clientNr, invoiceeNr), (_arg) => {
                let matchValue_2;
                dispatchSetInvoiceeDetailsAction((matchValue_2 = Result_Map((option) => map(validateInvoiceeDetails, option), _arg), (matchValue_2.tag === 1) ? (new LoadState$2(3, matchValue_2.fields[0])) : (new LoadState$2(2, matchValue_2.fields[0]))));
                return singleton.Zero();
            })));
        }
    }));
}

export function loadInvoiceeCurrentStateThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Invoicee.InvoiceeDetails.tag === 1) {
        }
        else {
            startImmediate(singleton.Delay(() => singleton.Bind(loadInvoiceeCurrentState(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                if (result.tag === 1) {
                    logei(toText(printf("Got error in Redux InvoiceeCurrentState: %s"))(result.fields[0]));
                    return singleton.Zero();
                }
                else {
                    const matchValue_1 = result.fields[0].CurrentState;
                    if (matchValue_1 == null) {
                        return singleton.Zero();
                    }
                    else {
                        dispatch(setInvoiceeCurrentState(InvoiceeStateModule_ofString(matchValue_1)));
                        return singleton.Zero();
                    }
                }
            })));
        }
    }));
}

export function loadInvoiceeBlockThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Invoicee.InvoiceeBlock.tag === 1) {
        }
        else {
            startImmediate(singleton.Delay(() => singleton.Bind(loadInvoiceeBlock(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                dispatch(setInvoiceeBlock((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, sortByDescending((ib) => ib.AtUtc, result.fields[0], {
                    Compare: compare,
                })))));
                return singleton.Zero();
            })));
        }
    }));
}

export function loadInvoiceeTerminationStateThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Invoicee.InvoiceeTerminationState.tag === 1) {
        }
        else {
            startImmediate(singleton.Delay(() => singleton.Bind(loadInvoiceeTerminationState(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                dispatch(setInvoiceeTerminationState((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]))));
                return singleton.Zero();
            })));
        }
    }));
}

